import React from "react";

export default function Phonetics({ phonetic }) {
  function playAudio() {
    new Audio(phonetic.audio).play();
  }

  if (!phonetic.audio) return null;

  return (
    <div>
      <button onClick={playAudio}>🔊</button>
      <span> {phonetic.text}</span>
    </div>
  );
}